<script setup>
import {
  beforeValue,
  afterValue,
  buttonKey,
  options,
  readMouseData,
  basekey,
  dpiLoop,
  mediaKey,
  systemKey,
  key_value,
  key_map,
  macro_key,
  macroBaseData,
  macro_key_map,
  gameKey,
  gameEventValue,
  otherLanguageKey,
  otherLanguageMediaKey,
  otherLanguageSystemKey,
} from "../baseData/index";
import {
  reportParams,
  getCheckSum,
  sendReport,
  mouseDevice,
} from "../common/index.js";
import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import { useStore } from "@/hooks/stores/global";
import { storeToRefs } from "pinia";
import { language } from "@/hooks/util/i18n";
import { reqInitData } from "../baseData/system";
import {
  NDropdown,
  NPopconfirm,
  NInput,
  NSelect,
  NButton,
  NInputNumber,
  NPopover,
  useDialog,
} from "naive-ui";
const dialog = useDialog();
const selected = ref([0, 1, 2, 4, 3, 6, 7]);
const selectedIndex = ref([0, 0, 0, 0, 0, 0, 0]);
const emit = defineEmits(["emitKeyIndex"]);
const defaultData = ref([]);
const keyBoardInput = ref(["", "", "", "", "", "", ""]);
const keyBoardSelected = ref([
  [false, false, false, false],
  [false, false, false, false],
  [false, false, false, false],
  [false, false, false, false],
  [false, false, false, false],
  [false, false, false, false],
  [false, false, false, false],
]);
const macroOptions = ref([]);
const macroName = ref([null, null, null, null, null, null, null]);
const main = useStore();
const {
  device,
  init,
  nameList,
  eventList,
  allMacroPacket,
  languageValue,
  currentMouse,
  deviceName,
} = storeToRefs(main);

onMounted(async () => {
  if (device.value) {
    // 读取鼠标的数据
    let { reportId, reportData } = reportParams(
      readMouseData + getCheckSum(readMouseData)
    );
    // 发送数据
    await device.value.sendReport(reportId, reportData);
  }
  for (let i = 0; i < nameList.value?.length; i++) {
    macroOptions.value.push({
      value: i,
      label: nameList.value[i].macro_name,
    });
  }
});
onMounted(async () => {
  if (device.value) {
    // 读取鼠标dpi的数据
    let { reportId, reportData } = reportParams(
      reqInitData + getCheckSum(reqInitData)
    );
    // 发送数据

    await device.value.sendReport(reportId, reportData);
  }
});

onUnmounted(() => {
  main.initData("");
  main.addDpi("");
});
watch(languageValue, (newValue) => {
  if (newValue && macroName.value[selectedValue.value.key]) {
    macroName.value[selectedValue.value.key] =
      language[languageValue.value]["已设置宏按键"];
  }
});
watch(init, (newValue) => {
  if (defaultData.value?.length || !newValue) {
    return;
  }

  const arr = newValue.split(" ");
  let count = 0;
  let str = "";

  for (let i = 5; i < 41; i++) {
    str += arr[i];
    count++;
    if (count === 4) {
      defaultData.value.push(str);
      count = 0;
      str = "";
    }
  }

  for (let i = 0; i < defaultData.value?.length; i++) {
    if (defaultData.value[i][1] == "9") {
      macroName.value[i > 6 ? i - 2 : i] =
        language[languageValue.value]["已设置宏按键"];
      selectedIndex.value[i > 6 ? i - 2 : i] = 5;
    }
    if (i === 5 || i === 6 || defaultData.value[i][1] == "9") {
      continue;
    }

    if (defaultData.value[i] === "00000000") {
      selectedIndex.value[i > 6 ? i - 2 : i] = 6;
      continue;
    }
    if (defaultData.value[i][0] == 1 || defaultData.value[i][0] == 3) {
      const str = defaultData.value[i][2] + defaultData.value[i][3];
      switch (Number(defaultData.value[i][0])) {
        case 1:
          keyValue.value[i > 6 ? i - 2 : i] = parseInt(str, 16);
          break;
        case 3:
          for (let j = 0; j < Object.values(macro_key).length; j++) {
            if (
              Object.values(macro_key)[j].toLowerCase() === str.toLowerCase()
            ) {
              const keyCode = Object.keys(macro_key)[j];
              gameKeyValue.value[i > 6 ? i - 2 : i] =
                String.fromCharCode(keyCode);

              break;
            }
          }
          break;
      }
      const count =
        defaultData.value[i][1] +
        defaultData.value[i][4] +
        defaultData.value[i][5];
      const rateValue = defaultData.value[i][6] + defaultData.value[i][7];
      gameKeyBoard.value[i > 6 ? i - 2 : i] = Number(defaultData.value[i][0]);
      keyCount.value[i > 6 ? i - 2 : i] = parseInt(count, 16);
      rate.value[i > 6 ? i - 2 : i] = parseInt(rateValue, 16);
      selectedIndex.value[i > 6 ? i - 2 : i] = 8;

      continue;
    }
    let flag = false;
    for (let j = 0; j < buttonKey?.length; j++) {
      for (let k = 0; k < buttonKey[j]?.length; k++) {
        if (
          buttonKey[j][k].toLowerCase() === defaultData.value[i].toLowerCase()
        ) {
          selected.value[i > 6 ? i - 2 : i] = k;
          selectedIndex.value[i > 6 ? i - 2 : i] = j;
          flag = true;
          break;
        }
      }
      if (flag) break;
    }

    if (!flag) {
      let num1 = defaultData.value[i].slice(2, 4).toLowerCase();
      let num2 = defaultData.value[i].slice(4, 6).toLowerCase();

      for (let j = 0; j < Object.values(macro_key).length; j++) {
        if (Object.values(macro_key)[j].toLowerCase() === num2.toLowerCase()) {
          const keyCode = Number(Object.keys(macro_key)[j]);

          keyBoardInput.value[i > 6 ? i - 2 : i] = String.fromCharCode(keyCode);
          key.value = keyCode;
          break;
        }
      }
      const arr = key_map[num1];

      for (let k = 0; k < arr?.length; k++) {
        keyBoardSelected.value[i > 6 ? i - 2 : i][arr[k]] = true;
      }
      selectedIndex.value[i > 6 ? i - 2 : i] = 7;
    }
  }
});

const isExistLeftKey = (idx) => {
  let leftKey = [];
  for (let i = 0; i < selected.value.length; i++) {
    // 判断是否存在左键
    if (selected.value[i] == 0 && selectedIndex.value[i] == 0) {
      leftKey.push(i);
    }
  }

  const index = leftKey.indexOf(selectedValue.value.key);
  if (index > -1 && (idx !== 0 || key !== "baseMouse")) {
    leftKey.splice(index, 1);
  }
  if (leftKey.length <= 0) {
    console.log("当前只有一个左键,无法更改");
    dialog.warning({
      showIcon: false,
      closable: false,
      content: "当前只有一个左键,无法更改",
      positiveText: "确认",
      positiveButtonProps: {
        color: "#b5d8f1",
        textColor: "black",
        style: {
          width: "62px",
          height: "22px",
        },
      },
      style: {
        background: "#031321",
        width: "134px",
        color: "#b5d8f1",
        width: "454px",
        border: "1px solid #114b5d",
        borderRadius: "8px",
      },
    });
    return true;
  }
  return false;
};

const sendOutputReport = (idx, key, macroType) => {
  if (!device.value) {
    dialog.warning({
      showIcon: false,
      closable: false,
      content:
        language[languageValue.value]["请使用2.4G模式或者有线模式连接设备"],
      positiveText: "确认",
      positiveButtonProps: {
        color: "#b5d8f1",
        textColor: "black",
        style: {
          width: "62px",
          height: "22px",
        },
      },
      style: {
        background: "#031321",
        width: "134px",
        color: "#b5d8f1",
        width: "454px",
        border: "1px solid #114b5d",
        borderRadius: "8px",
      },
    });
    // alert(language[languageValue.value]["请连接设备"]);
    return;
  }
  if (
    selectedValue.value.key === 0 &&
    localStorage.getItem(currentMouse.value + "Lock") != 1
  ) {
    dialog.warning({
      showIcon: false,
      closable: false,
      content: language[languageValue.value]["左键配置已经锁定,无法配置"],
      positiveText: "确认",
      positiveButtonProps: {
        color: "#b5d8f1",
        textColor: "black",
        style: {
          width: "62px",
          height: "22px",
        },
      },
      style: {
        background: "#031321",
        width: "134px",
        color: "#b5d8f1",
        width: "454px",
        border: "1px solid #114b5d",
        borderRadius: "8px",
      },
    });
    // alert(language[languageValue.value]["左键配置已经锁定,无法配置"]);
    return;
  }
  // 判断是否存在至少一个左键

  if (isExistLeftKey(idx)) {
    return;
  }

  selected.value[selectedValue.value.key] = idx;
  // disabledKeyTip.value[selectedValue.value.key] = false;
  if (key !== "keyBoard") {
    keyBoardInput.value[selectedValue.value.key] = "";
    keyBoardSelected.value[selectedValue.value.key] = [
      false,
      false,
      false,
      false,
    ];
  }
  if (key !== "macro") {
    main.deletePacket(selectedValue.value.id);
  }
  switch (key) {
    case "baseMouse":
      defaultData.value[selectedValue.value.id] = buttonKey[0][idx];
      selectedIndex.value[selectedValue.value.key] = 0;
      break;
    case "dpi":
      defaultData.value[selectedValue.value.id] = buttonKey[1][idx];
      selectedIndex.value[selectedValue.value.key] = 1;
      break;
    case "media":
      defaultData.value[selectedValue.value.id] = buttonKey[2][idx];
      selectedIndex.value[selectedValue.value.key] = 2;
      break;
    case "systemKey":
      defaultData.value[selectedValue.value.id] = buttonKey[3][idx];
      selectedIndex.value[selectedValue.value.key] = 3;
      break;
    case "gamekeyBoard":
      defaultData.value[selectedValue.value.id] = saveKeyBoardData.value;
      selectedIndex.value[selectedValue.value.key] = 8;
      break;
    case "keyBoard":
      defaultData.value[selectedValue.value.id] = saveKeyBoardData.value;
      selectedIndex.value[selectedValue.value.key] = 7;
      break;
    case "macro":
      initMacro();
      for (let i = 0; i < Object.keys(allMacroPacket.value).length; i++) {
        const key = Object.keys(allMacroPacket.value)[i];
        defaultData.value[key] = "09" + macroType + "0" + i + "00";
      }
      // defaultData.value[selectedValue.value.id] = "09" + macroType + packetIndex[] "0000";
      selectedIndex.value[selectedValue.value.key] = 5;
      break;
    case "disableKey":
      defaultData.value[selectedValue.value.id] = "00000000";
      selectedIndex.value[selectedValue.value.key] = 6;
      // disabledKeyTip.value[selectedValue.value.key] = true;
      break;
  }
  let value = beforeValue + defaultData.value.join("") + afterValue;

  value += getCheckSum(value);
  // 发送数据
  sendReport(value);
};
watch(
  selectedIndex,
  (newValue) => {
    if (newValue[selectedValue.value.key] != 5) {
      macroName.value[selectedValue.value.key] = null;
    }
  },
  { deep: true }
);
const initMacro = () => {
  for (let i = 0; i < options.length; i++) {
    const id = options[i].id;

    if (!(id in allMacroPacket)) {
      defaultData.value[id] = buttonKey[0][i > 4 ? i + 1 : i];
    }
  }
};
const selectedValue = ref({
  label: "按键1 左键",
  key: 0,
  id: 0,
});
// 点击点亮鼠标
const Fn = (e) => {
  const posObj = {
    cloudS: [
      { x: 80, x1: 175, y: 93, y1: 260 },
      { x: 225, x1: 310, y: 93, y1: 260 },
      { x: 180, x1: 218, y: 130, y1: 155 },

      { x: 60, x1: 75, y: 296, y1: 354 },
      { x: 60, x1: 75, y: 220, y1: 280 },

      { x: 180, x1: 218, y: 100, y1: 130 },
      { x: 180, x1: 218, y: 155, y1: 185 },
    ],
    v2: [
      { x: 45, x1: 155, y: 30, y1: 275 }, // 左键
      { x: 211, x1: 315, y: 30, y1: 275 }, // 右键
      { x: 165, x1: 210, y: 125, y1: 150 }, //中键

      { x: 30, x1: 50, y: 320, y1: 400 }, // 后退

      { x: 30, x1: 50, y: 220, y1: 300 }, // 前进
      { x: 165, x1: 210, y: 90, y1: 125 }, // 向上滚动
      { x: 165, x1: 210, y: 150, y1: 185 }, // 向下滚动
    ],
    cloud: [
      { x: 60, x1: 160, y: 40, y1: 260 },
      { x: 211, x1: 315, y: 50, y1: 275 },
      { x: 170, x1: 207, y: 130, y1: 155 },
      { x: 30, x1: 50, y: 300, y1: 360 },
      { x: 30, x1: 50, y: 225, y1: 285 },
      { x: 170, x1: 207, y: 100, y1: 125 },
      { x: 170, x1: 207, y: 160, y1: 175 },
    ],
    default: [
      { x: 60, x1: 160, y: 40, y1: 260 },
      { x: 211, x1: 315, y: 50, y1: 275 },
      { x: 170, x1: 207, y: 130, y1: 155 },
      { x: 30, x1: 50, y: 300, y1: 360 },
      { x: 30, x1: 50, y: 225, y1: 285 },
      { x: 170, x1: 207, y: 100, y1: 125 },
      { x: 170, x1: 207, y: 160, y1: 175 },
    ],
  };

  const x = Math.floor(e.offsetX);
  const y = Math.floor(e.offsetY);
  console.log(x, y);
  const posCount = 7;
  for (let i = 0; i < posCount; i++) {
    const pos = posObj[deviceName.value || "default"][i];
    if (x >= pos.x && x <= pos.x1 && y >= pos.y && y <= pos.y1) {
      emit("emitKeyIndex", i);
      // mouseImgIndex.value = i;
      switch (i) {
        case 3:
          selectedValue.value = { ...options[4] };
          break;
        case 4:
          selectedValue.value = { ...options[3] };
          break;
        default:
          selectedValue.value = { ...options[i] };
          break;
      }
      break;
    }
  }
};
onMounted(() => {
  document.getElementById("mouse").addEventListener("click", Fn);
});
// 移除点击监听
onUnmounted(() => {
  document.getElementById("mouse").removeEventListener("click", Fn);
});
const handleSelect = (key, option) => {
  console.log(key);
  selectedValue.value.label = option._label;
  selectedValue.value.key = key;
  selectedValue.value.id = option.id;
  emit("emitKeyIndex", key);
};
// 重置按键设置
const reset = async () => {
  selected.value = [0, 1, 2, 4, 3, 6, 7];
  selectedIndex.value = [0, 0, 0, 0, 0, 0, 0];
  // disabledKeyTip.value = [false, false, false, false, false, false, false];
  const resetData =
    "0009008202ff00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000";
  if (device.value) {
    sendReport(resetData + getCheckSum(resetData));
  }
};
const key = ref("");
const handle = (evt) => {
  if (keyType.value === "game") {
    gameKeyValue.value[selectedValue.value.key] = evt.key.toUpperCase();
  } else {
    keyBoardInput.value[selectedValue.value.key] = evt.key.toUpperCase();
  }

  key.value = evt.keyCode;
};
const gameKeyValue = ref(["", "", "", "", "", "", ""]);
const keyType = ref("");
const keyBoardFocus = (type = "") => {
  keyType.value = type;
  if (type === "game") {
    gameKeyValue.value[selectedValue.value.key] = "";
  } else {
    keyBoardInput.value[selectedValue.value.key] = "";
  }

  document.addEventListener("keyup", handle);
};
const keyBoardBlur = (type = "") => {
  keyType.value = type;
  document.removeEventListener("keyup", handle);
};
// 处理键盘组合键的点击
const handleKeyBoardClick = (evt) => {
  if (
    selectedValue.value.key === 0 &&
    localStorage.getItem(currentMouse.value + "Lock") != 1
  ) {
    dialog.warning({
      showIcon: false,
      closable: false,
      content: language[languageValue.value]["左键配置已经锁定,无法配置"],
      positiveText: "确认",
      positiveButtonProps: {
        color: "#b5d8f1",
        textColor: "black",
        style: {
          width: "62px",
          height: "22px",
        },
      },
      style: {
        background: "#031321",
        width: "134px",
        color: "#b5d8f1",
        width: "454px",
        border: "1px solid #114b5d",
        borderRadius: "8px",
      },
    });

    return;
  }
  const index = evt.target.dataset.index;
  keyBoardSelected.value[selectedValue.value.key][index] =
    !keyBoardSelected.value[selectedValue.value.key][index];
};
const saveKeyBoardData = ref("");
// 发送键盘组合键的鼠标数据
const posClick = () => {
  if (isExistLeftKey(0)) {
    // showKeyValue.value = "";
    keyBoardSelected.value[selectedValue.value.key] = [
      false,
      false,
      false,
      false,
    ];
    keyBoardInput.value[selectedValue.value.key] = "";
    return;
  }
  let flag = true;
  let sum = 0;
  for (
    let i = 0;
    i < keyBoardSelected.value[selectedValue.value.key]?.length;
    i++
  ) {
    if (keyBoardSelected.value[selectedValue.value.key][i]) {
      flag = false;
      sum += parseInt(key_value[i], 16);
    }
  }
  if (!key.value && flag) {
    return;
  }
  let value = macro_key[key.value] || "00";

  saveKeyBoardData.value =
    "00" + sum.toString(16).padStart(2, "0") + value + "00";
  sendOutputReport(0, "keyBoard");
};
const gameClick = () => {
  if (
    selectedValue.value.key === 0 &&
    localStorage.getItem(currentMouse.value + "Lock") != 1
  ) {
    dialog.warning({
      showIcon: false,
      closable: false,
      content: language[languageValue.value]["左键配置已经锁定,无法配置"],
      positiveText: "确认",
      positiveButtonProps: {
        color: "#b5d8f1",
        textColor: "black",
        style: {
          width: "62px",
          height: "22px",
        },
      },
      style: {
        background: "#031321",
        width: "134px",
        color: "#b5d8f1",
        width: "454px",
        border: "1px solid #114b5d",
        borderRadius: "8px",
      },
    });
    // alert(language[languageValue.value]["左键配置已经锁定,无法配置"]);
    return;
  }
  let value = gameKeyBoard.value[selectedValue.value.key];
  const count = keyCount.value[selectedValue.value.key]
    .toString(16)
    .padStart(3, "0");

  value += count.slice(0, 1);
  if (gameKeyBoard.value[selectedValue.value.key] == 1) {
    value += keyValue.value[selectedValue.value.key]
      .toString(16)
      .padStart(2, "0");
  } else {
    value += macro_key[key.value];
  }
  value +=
    count.slice(1) +
    rate.value[selectedValue.value.key].toString(16).padStart(2, "0");
  saveKeyBoardData.value = value;
  sendOutputReport(0, "gamekeyBoard");
};
const selectChange = (value) => {
  if (
    selectedValue.value.key === 0 &&
    localStorage.getItem(currentMouse.value + "Lock") != 1
  ) {
    dialog.warning({
      showIcon: false,
      closable: false,
      content: language[languageValue.value]["左键配置已经锁定,无法配置"],
      positiveText: "确认",
      positiveButtonProps: {
        color: "#b5d8f1",
        textColor: "black",
        style: {
          width: "62px",
          height: "22px",
        },
      },
      style: {
        background: "#031321",
        width: "134px",
        color: "#b5d8f1",
        width: "454px",
        border: "1px solid #114b5d",
        borderRadius: "8px",
      },
    });
    // alert(language[languageValue.value]["左键配置已经锁定,无法配置"]);
    return;
  }

  if (isExistLeftKey(0)) {
    return;
  }
  macroName.value[selectedValue.value.key] = value;
  // selectedIndex.value[selectedValue.value.key] = 5;
  const filterTimeLen = eventList.value[value].filter(
    (item) => Number(item.type) !== 1
  )?.length;
  const handleArray = [];
  let isTime = true;
  let firstEventIndex = null;
  const events = eventList.value[value];
  for (let i = 0; i < events?.length; i++) {
    if (Number(events[i].type) !== 1) {
      firstEventIndex = i;
      break;
    }
  }
  for (let i = firstEventIndex; i < events?.length; i++) {
    if (isTime) {
      // console.log("number", Number(events[i].type));
      if (Number(events[i].type) === 1) {
        const item = handleArray.pop();
        const sumTime =
          Number(item.value) + Number(events[i].value) > 10000
            ? 10000
            : Number(item.value) + Number(events[i].value);
        // console.log("item", sumTime, item.value, events[i].value);
        item.desc = `-${sumTime}ms`;
        item.value = sumTime;
        item.index = handleArray?.length;
        handleArray.push(item);
      } else {
        const obj = {
          ...events[i],
          index: handleArray?.length,
        };
        // obj.index = handleArray?.length;
        handleArray.push(obj);
        isTime = false;
      }
    } else {
      // console.log("num", Number(events[i].type));
      if (Number(events[i].type) !== 1) {
        handleArray.push({
          desc: `-10ms`,
          index: handleArray?.length,
          value: 10,
          type: 1,
        });
        isTime = false;
      } else {
        isTime = true;
      }
      const obj = {
        ...events[i],
        index: handleArray?.length,
      };
      // events[i].index = handleArray?.length;

      handleArray.push(obj);
    }
  }
  // console.log("handleArray", handleArray, filterTimeLen);
  if (
    handleArray?.length &&
    Number(handleArray[handleArray?.length - 1].type) !== 1
  ) {
    handleArray.push({
      desc: `-10ms`,
      index: handleArray?.length,
      value: 10,
      type: 1,
    });
  }
  handleMacroData(handleArray, filterTimeLen, value);
};
const handleMacroData = async (handleArray, len, currentName) => {
  let str = "";
  if (handleArray?.length) {
    str = len.toString(16).padStart(2, "0") + "00";
  }

  for (let i = 0; i < handleArray?.length; i++) {
    switch (Number(handleArray[i].type)) {
      case 1:
        const delay = handleArray[i].value.toString(16).padStart(4, "0");
        str += delay.slice(2, 4) + delay.slice(0, 2);
        break;
      case 2:
        str += "01" + macro_key[handleArray[i].value];
        break;
      case 3:
        str += "81" + macro_key[handleArray[i].value];
        break;
      case 4:
        str += "04" + handleArray[i].value.toString(16).padStart(2, "0");
        break;
      case 5:
        str += "84" + handleArray[i].value.toString(16).padStart(2, "0");
        break;
    }
  }
  if (!str?.length) {
    return;
  }
  const packetArray = [];
  let dataLen = str?.length / 2;
  // let firstLen = 40;
  let byteNum = 128;
  let packetData = "";
  if (dataLen >= 20) {
    byteNum += 60;
    packetData = str.slice(0, 20 * 2);
    str = str.slice(20 * 2);
  } else {
    byteNum += dataLen + 40;
    packetData = str.slice(0).padEnd(20 * 2, 0);
    str = "";
  }

  const macroType =
    macro_key_map[
      nameList.value[currentName].play_times > 1
        ? 4
        : nameList.value[currentName].macro_type
    ];
  // console.log("len", Object.keys(allMacroPacket.value).length);
  const firstPacket =
    "000700" +
    byteNum.toString(16) +
    "0200" +
    macroType +
    nameList.value[currentName].play_times.toString(16).padStart(2, "0") +
    macroBaseData +
    packetData;
  packetArray.push(firstPacket);
  const num = Math.ceil(str?.length / 58 / 2);
  for (let i = 0; i < num; i++) {
    let byteNum = 128;
    let packetData = "";
    if (i !== num - 1 && num > 1) {
      byteNum += 60;
      packetData = str.slice(0, 58 * 2);
      str = str.slice(58 * 2);
    } else {
      byteNum += 2 + str?.length / 2;
      packetData = str.slice(0).padEnd(58 * 2, "0");
      str = "";
    }
    const packet =
      "0007" +
      (i + 1).toString(16).padStart(2, "0") +
      byteNum.toString(16) +
      "0200" +
      packetData;
    packetArray.push(packet);
  }

  main.addPacket(selectedValue.value.id, packetArray);

  for (let j = 0; j < Object.keys(allMacroPacket.value)?.length; j++) {
    const key = Object.keys(allMacroPacket.value)[j];
    const packetArray = allMacroPacket.value[key];

    for (let i = 0; i < packetArray?.length; i++) {
      let update = packetArray[i].slice(0, 11) + j + packetArray[i].slice(12);

      let value = update + getCheckSum(update);
      // 发送数据
      if (device.value) {
        setTimeout(async () => {
          let { reportId, reportData } = reportParams(value);
          // 发送数据
          await device.value.sendReport(reportId, reportData);
        }, j * 100);

        // setTimeout(() => {}, 1000)
      }
    }
  }
  setTimeout(() => {
    sendOutputReport(0, "macro", macroType);
  }, 1000);
};
const disableKey = () => {
  if (
    selectedValue.value.key === 0 &&
    localStorage.getItem(currentMouse.value + "Lock") != 1
  ) {
    dialog.warning({
      showIcon: false,
      closable: false,
      content: language[languageValue.value]["左键配置已经锁定,无法配置"],
      positiveText: "确认",
      positiveButtonProps: {
        color: "#b5d8f1",
        textColor: "black",
        style: {
          width: "62px",
          height: "22px",
        },
      },
      style: {
        background: "#031321",
        width: "134px",
        color: "#b5d8f1",
        width: "454px",
        border: "1px solid #114b5d",
        borderRadius: "8px",
      },
    });
    // alert(language[languageValue.value]["左键配置已经锁定,无法配置"]);
    return;
  }
  if (isExistLeftKey(0)) {
    return;
  }
  try {
    sendOutputReport(0, "disableKey");
    // disabledKeyTip.value[selectedValue.value.key] = true;
    dialog.warning({
      showIcon: false,
      closable: false,
      content: language[languageValue.value]["设置成功"],
      positiveText: "确认",
      positiveButtonProps: {
        color: "#b5d8f1",
        textColor: "black",
        style: {
          width: "62px",
          height: "22px",
        },
      },
      style: {
        background: "#031321",
        width: "134px",
        color: "#b5d8f1",
        width: "454px",
        border: "1px solid #114b5d",
        borderRadius: "8px",
      },
    });
    // alert(language[languageValue.value]["设置成功"]);
  } catch (err) {
    dialog.warning({
      showIcon: false,
      closable: false,
      content: "设置失败",
      positiveText: "确认",
      positiveButtonProps: {
        color: "#b5d8f1",
        textColor: "black",
        style: {
          width: "62px",
          height: "22px",
        },
      },
      style: {
        background: "#031321",
        width: "134px",
        color: "#b5d8f1",
        width: "454px",
        border: "1px solid #114b5d",
        borderRadius: "8px",
      },
    });
    // alert("设置失败");
  }
};

// 展示键盘组件键

const showKeyValue = computed(() => {
  let str = "";
  const arr = ["Ctrl", "Win", "Alt", "Shift"];

  for (
    let i = 0;
    i < keyBoardSelected.value[selectedValue.value.key]?.length;
    i++
  ) {
    if (keyBoardSelected.value[selectedValue.value.key][i]) {
      str += arr[i] + "+";
    }
  }
  if (keyBoardInput.value[selectedValue.value.key]) {
    str += keyBoardInput.value[selectedValue.value.key];
  } else {
    str = str.slice(0, -1);
  }
  return str;
});

const gameKeyBoard = ref([1, 1, 1, 1, 1, 1, 1]);

const keyValue = ref([1, 1, 1, 1, 1, 1, 1]);
const keyCount = ref([1, 1, 1, 1, 1, 1, 1]);
const rate = ref([10, 10, 10, 10, 10, 10, 10]);
const keyBoardShow = ref([false, false, false, false, false, false, false]);
const gameShow = ref([false, false, false, false, false, false, false]);
</script>

<template>
  <div class="bg">
    <div class="linear" style="margin-top: 24px"></div>
    <div class="top">
      <n-dropdown
        trigger="hover"
        placement="bottom-start"
        :options="
          options.map((item) => ({
            ...item,
            label: language[languageValue][item.label],
          }))
        "
        @select="handleSelect"
        :inverted="true"
      >
        <img src="@/images/zhuanhuan.png" alt="" style="cursor: pointer" />
      </n-dropdown>
      <span class="middle">{{
        language[languageValue][selectedValue.label]
      }}</span>

      <n-popconfirm
        @positive-click="reset"
        :positive-text="language[languageValue]['是']"
        :negative-text="language[languageValue]['否']"
        :show-icon="false"
        trigger="hover"
      >
        <template #trigger>
          <img src="@/images/refresh.png" alt="" style="cursor: pointer" />
        </template>

        {{ language[languageValue]["是否重置当前所有按键设置"] }}
      </n-popconfirm>
    </div>
    <div class="linear"></div>
    <div class="content">
      <div class="line">
        <div class="white">{{ language[languageValue]["基础鼠标功能"] }}</div>
        <div
          v-for="(item, index) in languageValue === 'zh'
            ? basekey
            : otherLanguageKey"
          :key="index"
          class="key"
        >
          <span
            :style="{ cursor: 'pointer' }"
            v-for="(i, j) in item"
            :key="j"
            @click="sendOutputReport(i.idx, 'baseMouse')"
            :class="{
              selected:
                selected[selectedValue.key] === i.idx &&
                selectedIndex[selectedValue.key] === 0,
            }"
            >{{ language[languageValue][i.value] }}</span
          >
        </div>
      </div>
      <div class="line">
        <div class="white">{{ language[languageValue]["灵敏度"] }}</div>
        <div v-for="(item, index) in dpiLoop" :key="index" class="key">
          <span
            v-for="(i, j) in item"
            :key="j"
            :style="{ cursor: 'pointer' }"
            :class="{
              selected:
                selected[selectedValue.key] === i.idx &&
                selectedIndex[selectedValue.key] === 1,
            }"
            @click="sendOutputReport(i.idx, 'dpi')"
            >{{ language[languageValue][i.value] }}</span
          >
        </div>
      </div>
      <div class="line">
        <div class="white">{{ language[languageValue]["多媒体按键"] }}</div>
        <div
          v-for="(item, index) in languageValue === 'zh'
            ? mediaKey
            : otherLanguageMediaKey"
          :key="index"
          class="key"
        >
          <span
            v-for="(i, j) in item"
            :key="j"
            @click="sendOutputReport(i.idx, 'media')"
            :style="{ cursor: 'pointer' }"
            :class="{
              selected:
                selected[selectedValue.key] === i.idx &&
                selectedIndex[selectedValue.key] === 2,
            }"
            >{{ language[languageValue][i.value] }}</span
          >
          <span
            v-if="index === 2 && languageValue === 'zh' ? true : false"
          ></span>
        </div>
      </div>
      <div class="line">
        <div class="white">{{ language[languageValue]["系统快捷键"] }}</div>
        <div
          v-for="(item, index) in languageValue === 'zh'
            ? systemKey
            : otherLanguageSystemKey"
          :key="index"
          class="key"
        >
          <span
            v-for="(i, j) in item"
            :key="j"
            :style="{ cursor: 'pointer' }"
            :class="{
              selected:
                selected[selectedValue.key] === i.idx &&
                selectedIndex[selectedValue.key] === 3,
            }"
            @click="sendOutputReport(i.idx, 'systemKey')"
            >{{ language[languageValue][i.value] }}</span
          >
          <span
            v-if="index === 3 && languageValue === 'zh' ? true : false"
          ></span>
        </div>
      </div>
      <div class="line">
        <div class="white">{{ language[languageValue]["宏按键"] }}</div>
        <n-select
          :value="macroName[selectedValue.key]"
          :options="
            macroOptions.map((item) => {
              if (item.label.slice(0, 2) === '名称') {
                return {
                  ...item,
                  label: language[languageValue]['名称'] + item.label.slice(2),
                };
              } else {
                return item;
              }
            })
          "
          size="small"
          :placeholder="language[languageValue]['请选择']"
          style="margin-bottom: 10px"
          @update-value="selectChange"
        >
          <template #empty>
            <div
              style="
                height: 90px;
                line-height: 90px;
                font-size: 14px;
                color: rgba(194, 194, 194, 1);
              "
            >
              {{ language[languageValue]["没有数据"] }}
            </div>
          </template>
        </n-select>
      </div>
      <div
        class="line"
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <div class="white">{{ language[languageValue]["键盘组合键"] }}</div>
        <n-popconfirm
          v-model:show="keyBoardShow[selectedValue.key]"
          :show-icon="false"
          :positive-text="language[languageValue]['保存']"
          :negative-text="null"
          @positive-click="posClick"
          style="background: linear-gradient(90deg, #133447, #020c16)"
        >
          <template #trigger>
            <span style="cursor: pointer">{{
              language[languageValue]["设置"]
            }}</span>
          </template>
          <div style="color: #fff">
            <div>{{ language[languageValue]["键盘组合键"] }}</div>
            <n-input
              v-model:value="keyBoardInput[selectedValue.key]"
              size="small"
              round
              :placeholder="language[languageValue]['请输入单键']"
              style="margin: 10px 0; text-align: center"
              @focus="keyBoardFocus"
              @blur="keyBoardBlur"
            />
            <div style="margin: 10px 0" @click="handleKeyBoardClick">
              <span
                class="keyBoard"
                :data-index="0"
                :class="{ click: keyBoardSelected[selectedValue.key][0] }"
                >Ctrl</span
              >
              <span
                class="keyBoard"
                :data-index="1"
                :class="{ click: keyBoardSelected[selectedValue.key][1] }"
                >Win</span
              >
              <span
                class="keyBoard"
                :data-index="2"
                :class="{ click: keyBoardSelected[selectedValue.key][2] }"
                >Alt</span
              >
              <span
                class="keyBoard"
                :data-index="3"
                :class="{ click: keyBoardSelected[selectedValue.key][3] }"
                >Shift</span
              >
            </div>
          </div>
        </n-popconfirm>
      </div>
      <div class="show">{{ showKeyValue }}</div>
      <div
        class="line"
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <div class="white">
          <span style="margin-right: 10px">{{
            language[languageValue]["游戏增强按键"]
          }}</span>
          <n-popover trigger="hover">
            <template #trigger>
              <img
                src="@/images/rate-icon2.png"
                alt=""
                style="
                  cursor: pointer;
                  vertical-align: middle;
                  margin-top: -2px;
                "
              />
            </template>
            <span>{{ language[languageValue]["每秒自动击键的次数"] }}</span>
          </n-popover>
        </div>
        <n-popconfirm
          v-model:show="gameShow[selectedValue.key]"
          :show-icon="false"
          :positive-text="language[languageValue]['保存']"
          :negative-text="null"
          @positive-click="gameClick"
          style="background: linear-gradient(90deg, #133447, #020c16)"
        >
          <template #trigger>
            <span style="cursor: pointer">{{
              language[languageValue]["设置"]
            }}</span>
          </template>
          <div style="width: 300px; color: #fff">
            <div style="margin-bottom: 10px">
              {{ language[languageValue]["游戏增强按键"] }}
            </div>
            <div style="display: flex">
              <n-select
                v-model:value="gameKeyBoard[selectedValue.key]"
                :options="gameKey"
                size="small"
                :placeholder="language[languageValue]['请选择']"
                style="margin-bottom: 10px"
              />
              <div style="width: 60px; margin: 2px 5px 0">
                {{ language[languageValue]["键值"] }}
              </div>

              <n-select
                v-if="gameKeyBoard[selectedValue.key] === 1"
                v-model:value="keyValue[selectedValue.key]"
                :options="gameEventValue"
                size="small"
                :placeholder="language[languageValue]['请选择']"
                style="margin-bottom: 10px; width: 190px"
              />
              <n-input
                v-else
                v-model:value="gameKeyValue[selectedValue.key]"
                size="small"
                :placeholder="language[languageValue]['请输入单键']"
                style="height: 28px; text-align: center; width: 190px"
                @focus="keyBoardFocus('game')"
                @blur="keyBoardBlur('game')"
              />
            </div>
            <div style="display: flex">
              <div style="width: 60px; line-height: 47px; margin-right: 15px">
                {{ language[languageValue]["次数"] }}
              </div>
              <n-input-number
                v-model:value="keyCount[selectedValue.key]"
                :max="4000"
                :min="1"
                size="small"
                round
                :placeholder="language[languageValue]['请输入']"
                style="margin: 10px 0; text-align: center; width: 190px"
              />
              <div
                style="
                  width: 60px;
                  line-height: 47px;
                  margin-left: 5px;
                  margin-right: 15px;
                "
              >
                {{ language[languageValue]["速率"] }}
              </div>
              <n-input-number
                :max="255"
                v-model:value="rate[selectedValue.key]"
                size="small"
                round
                :placeholder="language[languageValue]['请输入']"
                style="margin: 10px 0; text-align: center; width: 190px"
              />
              <div style="width: 60px; line-height: 47px">ms</div>
            </div>
          </div>
        </n-popconfirm>
      </div>
      <div class="show">
        {{
          selectedIndex[selectedValue.key] == 8
            ? language[languageValue]["已设置游戏增强按键"]
            : ""
        }}
      </div>
      <div
        class="line"
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <div class="white">{{ language[languageValue]["禁用按键"] }}</div>

        <n-button type="info" @click="disableKey" size="tiny">{{
          language[languageValue]["禁用按键"]
        }}</n-button>
      </div>
      <div class="show">
        {{
          selectedIndex[selectedValue.key] == 6
            ? language[languageValue]["已设置禁用按键"]
            : ""
        }}
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.bg {
  //   background-color: #ccc;
  color: #8aaac0;
  width: 288px;
  // margin-left: 40px;
  .line {
    border-bottom: 3px solid #153a55;
  }
  .show {
    margin-top: 10px;
    width: 100%;
    height: 28px;
    line-height: 28px;
    box-sizing: border-box;
    padding: 0 10px;
    // color: #fff;
    background-color: rgba(255, 255, 255, 1);
  }
  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: linear-gradient(66deg, #020612, #16221e);
    margin-bottom: 16px;

    height: 64px;
    border-bottom-right-radius: 15px;
    padding: 0 18px 0 26px;
    .middle {
      font-family: "PingFang";
      font-weight: bold;
      font-size: 17px;
      color: #b5d8f1;
    }
  }
  .content {
    padding: 15px;
    overflow: auto;
    height: 680px;
    box-sizing: border-box;
    background: linear-gradient(90deg, #133447, #020c16);
    opacity: 0.63;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
  }
  .linear {
    width: 288px;
    height: 3px;
    background: linear-gradient(90deg, #457287, #387d8c, #385d65);
  }
}
.key {
  display: flex;
  span {
    flex: 1;
    margin: 5px 0;
  }
}
.white {
  color: #fff;
  margin: 8px 0;
}
.selected {
  color: #fff;
  position: relative;
  &::after {
    content: "";
    position: absolute;
    top: 6px;
    width: 0;
    height: 0;
    margin-left: 0px;
    border-style: solid;
    border-width: 5px;
    border-color: transparent #fff transparent transparent;
  }
}
.keyBoard {
  padding: 4px;
  // color: #fff;
  // background-color: #183e48;
  margin-right: 5px;
  border-radius: 5px;
  cursor: pointer;
  border: 1px solid #fff;
}
.click {
  color: #fff;
  background-color: #183e48;
}
</style>
